<template>
  <a ref="container" :href="computedHref" v-bind="$attrs">
      <template v-if="contact">{{ contact }}</template>
      <slot v-else />
  </a>
</template>

<script>
import VueCookies from 'vue-cookies';
import ContactInfo from './ContactInfo.vue';

export default {
    extends: ContactInfo,
    props: {
        href: String,
    },
    computed: {
        computedHref() {
            if (!this.contact) {
                return this.href;
            }
            if (this.type === 'phone') {
                return 'tel:' + this.contact.replaceAll(' ', '-');
            } else if (this.type === 'email') {
                return 'mailto:' + this.contact;
            } else {
                return '#' + this.contact;
            }
        }
    }
}
</script>
